import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_part_of_the_ongoing_comm_and'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_part_of_the_ongoing_comm_and',
  name: 'Which of the following topics are part of the on-going communication and training to EXISTING production workers?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RECRUITMENT_AND_HIRING',
      text: 'Recruitment and hiring',
      externalIds: [
        {
          id: 'ms-5--9-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TERMINATION_AND_RETRENCHMENT',
      text: 'Termination and retrenchment',
      externalIds: [
        {
          id: 'ms-5--9-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_WORKPLACE_RULES',
      text: 'Facility workplace rules',
      externalIds: [
        {
          id: 'ms-5--9-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CHILD_LABOR_AND_YOUNG_WORKERS',
      text: 'Child labor and young workers',
      externalIds: [
        {
          id: 'ms-5--9-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PROHIBITION_OF_FORCED_LABOR',
      text: 'Prohibition of forced labor',
      externalIds: [
        {
          id: 'ms-5--9-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ANTI_HARASSMENT_AND_ABUSE',
      text: 'Anti-harassment and abuse',
      externalIds: [
        {
          id: 'ms-5--9-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ANTI_DISCRIMINATION',
      text: 'Anti-discrimination',
      externalIds: [
        {
          id: 'ms-5--9-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKING_HOURS',
      text: 'Working Hours',
      externalIds: [
        {
          id: 'ms-5--9-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WAGES_AND_BENEFITS',
      text: 'Wages and Benefits',
      externalIds: [
        {
          id: 'ms-5--9-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DISCIPLINE',
      text: 'Discipline',
      externalIds: [
        {
          id: 'ms-5--9-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
      text: 'Freedom of association and collective bargaining',
      externalIds: [
        {
          id: 'ms-5--9-11x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'GRIEVANCE_SYSTEMS',
      text: 'Grievance systems',
      externalIds: [
        {
          id: 'ms-5--9-12x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKER_FEEDBACK',
      text: 'Worker Feedback',
      externalIds: [
        {
          id: 'ms-5--9-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HEALTH_AND_SAFETY',
      text: 'Health and safety',
      externalIds: [
        {
          id: 'ms-5--9-14x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PLEASE_PROVIDE_A_LIST_OF_ALL_HEALTH_AND_SAFETY_TRAININGS_OFFERE',
      text: 'Please provide a list of all health and safety trainings offered to EXISTING production workers in the facility',
      externalIds: [
        {
          id: 'ms-do-22f',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MIGRANT_WORKERS',
      text: 'Migrant workers',
      externalIds: [
        {
          id: 'ms-5--9-16x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOMEWORKERS',
      text: 'Homeworkers',
      externalIds: [
        {
          id: 'ms-5--9-17x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SUPPLIERS_SUBCONTRACTORS',
      text: 'Suppliers/subcontractors',
      externalIds: [
        {
          id: 'ms-5--9-18x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BRIBERY_AND_ANTI_CORRUPTION',
      text: 'Bribery and anti-corruption',
      externalIds: [
        {
          id: 'ms-5--9-19x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-5--9-20x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-5--9-20f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RECRUITMENT_AND_HIRING',
                'TERMINATION_AND_RETRENCHMENT',
                'FACILITY_WORKPLACE_RULES',
                'CHILD_LABOR_AND_YOUNG_WORKERS',
                'PROHIBITION_OF_FORCED_LABOR',
                'ANTI_HARASSMENT_AND_ABUSE',
                'ANTI_DISCRIMINATION',
                'WORKING_HOURS',
                'WAGES_AND_BENEFITS',
                'DISCIPLINE',
                'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
                'GRIEVANCE_SYSTEMS',
                'WORKER_FEEDBACK',
                'HEALTH_AND_SAFETY',
                'PLEASE_PROVIDE_A_LIST_OF_ALL_HEALTH_AND_SAFETY_TRAININGS_OFFERE',
                'MIGRANT_WORKERS',
                'HOMEWORKERS',
                'SUPPLIERS_SUBCONTRACTORS',
                'BRIBERY_AND_ANTI_CORRUPTION',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-do-21',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 22490,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
